// extracted by mini-css-extract-plugin
export default {"printModal":"printModal-DCxqf"};